<script setup lang="ts">
import { vIntersectionObserver } from "@vueuse/components";
import VAppLink from "@magnit/core/src/components/VAppLink/VAppLink.vue";
import VInlineButton from "@magnit/core/src/components/VInlineButton/VInlineButton.vue";
import VWrapper from "@magnit/core/src/components/VWrapper/VWrapper.vue";
import { useAnalyticManager } from "@magnit/analytic-events";
import { type IHeaderBottomMenuLink } from "../header.types";

defineProps<{
  items: IHeaderBottomMenuLink[];
}>();

const { send } = useAnalyticManager();

const onItemClick = (item: IHeaderBottomMenuLink) => {
  send("QuickLinks:Item:Click", { url: item.url, label: item.label });
};
const onVisibility = (
  [{ isIntersecting }]: IntersectionObserverEntry[],
  item: IHeaderBottomMenuLink,
) => {
  if (!isIntersecting) return;
  send("QuickLinks:Item:View", { url: item.url, label: item.label });
};
</script>

<template>
  <VWrapper
    :indent="{ xs: '12px', s: '20px', m: '32px' }"
    class="pl-header-bottom-menu-wrapper"
  >
    <div class="pl-header-bottom-menu">
      <VAppLink
        v-for="item in items"
        :key="item.url"
        :to="item.url"
        :target="item.target"
        :rel="item.rel"
      >
        <VInlineButton
          v-intersection-observer="
            (arg: IntersectionObserverEntry[]) => onVisibility(arg, item)
          "
          icon-position="left"
          theme="secondary"
          tag="span"
          size="l"
          class="pl-header-bottom-menu__button"
          @click="onItemClick(item)"
        >
          {{ item.label }}
          <template v-if="item.icon" #icon>
            <component :is="item.icon" />
          </template>
        </VInlineButton>
      </VAppLink>
    </div>
  </VWrapper>
</template>

<style scoped lang="postcss">
.pl-header-bottom-menu {
  display: flex;
  flex-wrap: nowrap;
  padding: var(--pl-unit-x3) 0;
  gap: 24px;
  overflow: visible;

  &__button {
    white-space: nowrap;
  }

  &-wrapper {
    -ms-overflow-style: none;
    align-items: center;
    display: flex;
    justify-content: space-between;
    overflow-x: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
